import React from 'react';

const SustentareLogo = () => (
  <svg
    width="386"
    height="75"
    viewBox="0 0 386 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.61406 73.3117L0.727846 64.492H12.0499C12.9942 64.492 13.2844 64.2303 13.2844 63.512V54.8896C13.2844 53.5838 12.7753 53.5172 11.3244 53.5172H5.87985C2.75915 53.5172 0 52.8631 0 48.1606V32.091C0 28.3685 2.1764 25.9495 7.11433 25.9495H21.6308L23.4457 34.7692H11.5409C10.6703 34.7692 10.235 35.0951 10.235 35.8134V44.4358C10.235 45.4158 10.744 45.6774 11.8311 45.6774H18.4364C21.7759 45.6774 23.6621 46.9832 23.6621 50.5107V66.1237C23.6621 71.3494 21.6308 73.3094 15.6059 73.3094H2.61406V73.3117Z"
      fill="#00B033"
    />
    <path
      d="M36.221 73.3117C30.1961 73.3117 28.0197 71.221 28.0197 65.9952V25.9495H38.7613V63.9687C38.7613 64.687 38.9064 65.0129 39.777 65.0129H43.478C44.3486 65.0129 44.4937 64.687 44.4937 63.9687V25.9495H55.2354V65.9952C55.2354 71.221 53.059 73.3117 47.034 73.3117H36.2186H36.221Z"
      fill="#00B033"
    />
    <path
      d="M62.2046 73.3117L60.3184 64.492H71.6405C72.5848 64.492 72.8749 64.2303 72.8749 63.512V54.8896C72.8749 53.5838 72.3659 53.5172 70.915 53.5172H65.4704C62.3497 53.5172 59.5906 52.8631 59.5906 48.1606V32.091C59.5906 28.3685 61.767 25.9495 66.7049 25.9495H81.2214L83.0362 34.7692H71.1314C70.2609 34.7692 69.8256 35.0951 69.8256 35.8134V44.4358C69.8256 45.4158 70.3346 45.6774 71.4216 45.6774H78.0269C81.3665 45.6774 83.2527 46.9832 83.2527 50.5107V66.1237C83.2527 71.3494 81.2214 73.3094 75.1964 73.3094H62.2046V73.3117Z"
      fill="#00B033"
    />
    <path
      d="M107.64 25.9518L110.254 34.7716H103.214V73.3141H92.472V34.7716H85.4314L88.1905 25.9518H107.643H107.64Z"
      fill="#00B033"
    />
    <path
      d="M113.156 25.9518H133.626L135.441 34.7716H123.972V46.008H132.682V54.1737H123.972V64.4943H135.003L133.189 73.3141H113.156V25.9518Z"
      fill="#00B033"
    />
    <path
      d="M139.068 25.9518H149.085L154.455 44.9615V25.9518H165.271V73.3141H154.455L148.794 53.5196V73.3141H139.068V25.9518Z"
      fill="#00B033"
    />
    <path
      d="M190.386 25.9518L193 34.7716H185.96V73.3141H175.218V34.7716H168.177L170.937 25.9518H190.389H190.386Z"
      fill="#00B033"
    />
    <path
      d="M201.634 67.4319L200.69 73.3117H190.094L199.603 25.9495H210.854L220.363 73.3117H209.767L208.823 67.4319H201.637H201.634ZM202.798 59.9203H207.662L205.267 43.1323L202.798 59.9203Z"
      fill="#00B033"
    />
    <path
      d="M250.338 54.0405C250.338 56.1313 248.669 58.222 245.622 58.222L251.138 73.3117H240.251L235.17 58.222H233.791V73.3117H223.265V25.9495H243.226C248.162 25.9495 250.341 28.3661 250.341 32.091V54.0405H250.338ZM233.791 34.2483V50.5797H238.945C239.744 50.5797 239.961 50.318 239.961 49.5997V35.2283C239.961 34.6408 239.67 34.2483 238.945 34.2483H233.791Z"
      fill="#00B033"
    />
    <path
      d="M252.151 73.3117V68.4904H257.507V73.3117H252.151Z"
      fill="#F0EAD7"
    />
    <path
      d="M282.782 58.5788L294.038 60.6268C292.591 65.1009 290.306 68.5094 287.185 70.8475C284.062 73.188 280.156 74.3559 275.468 74.3559C268.045 74.3559 262.55 71.7252 258.987 66.4662C256.173 62.2537 254.767 56.9352 254.767 50.513C254.767 42.8421 256.615 36.8338 260.314 32.4905C264.013 28.1473 268.689 25.9732 274.343 25.9732C280.694 25.9732 285.706 28.2472 289.378 32.795C293.048 37.3428 294.804 44.3097 294.644 53.6956H266.344C266.425 57.3277 267.336 60.1534 269.077 62.1728C270.818 64.1922 272.99 65.2031 275.589 65.2031C277.359 65.2031 278.846 64.6799 280.052 63.6333C281.258 62.5867 282.169 60.9027 282.785 58.5764L282.782 58.5788ZM283.424 46.2007C283.344 42.6566 282.499 39.9617 280.891 38.1159C279.283 36.2701 277.326 35.3472 275.023 35.3472C272.557 35.3472 270.521 36.3201 268.913 38.2681C267.305 40.2162 266.515 42.8588 266.541 46.2007H283.424Z"
      fill="#F0EAD7"
    />
    <path
      d="M9.49761 0.355957C11.3957 0.355957 12.3614 1.40491 12.3614 2.9938V13.393C12.3614 15.0413 11.6288 16.2996 8.93151 16.2996H4.8023V22.0843H0.00708008V0.355957H9.49761ZM4.8023 4.16406V12.7055H7.1999C7.59951 12.7055 7.66611 12.5866 7.66611 12.256V4.58269C7.66611 4.31391 7.56621 4.16406 7.2332 4.16406H4.8023Z"
      fill="#00B033"
    />
    <path
      d="M26.6805 13.2455C26.6805 14.204 25.9146 15.1626 24.516 15.1626L27.0468 22.0867H22.0517L19.7207 15.1626H19.088V22.0867H14.2595V0.355957H23.4171C25.6815 0.355957 26.6805 1.46438 26.6805 3.17219V13.2431V13.2455ZM19.088 4.16406V11.6566H21.4523C21.8186 11.6566 21.9185 11.5377 21.9185 11.207V4.61361C21.9185 4.34483 21.7853 4.16406 21.4523 4.16406H19.088Z"
      fill="#00B033"
    />
    <path
      d="M41.266 18.9993C41.266 20.6477 40.5001 22.0867 37.8027 22.0867H32.2083C29.511 22.0867 28.7451 20.6477 28.7451 18.9993V3.17461C28.7451 1.46679 29.7441 0.358368 32.0085 0.358368H38.0025C40.267 0.358368 41.266 1.46679 41.266 3.17461V18.9993ZM34.0398 4.1641C33.7068 4.1641 33.6069 4.31395 33.6069 4.58273V17.8314C33.6069 18.162 33.6735 18.281 34.0731 18.281H35.9046C36.3042 18.281 36.3708 18.162 36.3708 17.8314V4.58273C36.3708 4.31395 36.2709 4.1641 35.9379 4.1641H34.0398Z"
      fill="#00B033"
    />
    <path
      d="M43.264 2.9938C43.264 1.40491 44.2297 0.355957 46.1278 0.355957H53.021L53.8535 4.40192H48.5588C48.2258 4.40192 48.1259 4.55177 48.1259 4.82055V17.7077C48.1259 17.9765 48.2258 18.1263 48.5588 18.1263H50.7566V9.55393H55.4519V22.0819H47.0269C44.263 22.0819 43.264 21.1233 43.264 18.7257V2.9938Z"
      fill="#00B033"
    />
    <path
      d="M69.7709 13.2455C69.7709 14.204 69.005 15.1626 67.6064 15.1626L70.1372 22.0867H65.1422L62.8112 15.1626H62.1785V22.0867H57.35V0.355957H66.5075C68.7719 0.355957 69.7709 1.46438 69.7709 3.17219V13.2431V13.2455ZM62.1785 4.16406V11.6566H64.5428C64.9091 11.6566 65.009 11.5377 65.009 11.207V4.61361C65.009 4.34483 64.8758 4.16406 64.5428 4.16406H62.1785Z"
      fill="#00B033"
    />
    <path
      d="M76.231 19.3894L75.7981 22.0867H70.9363L75.2986 0.358368H80.4601L84.8224 22.0867H79.9606L79.5277 19.3894H76.231ZM76.7638 15.9428H78.9949L77.896 8.24098L76.7638 15.9428Z"
      fill="#00B033"
    />
    <path
      d="M90.8499 11.835V22.0843H86.1545V0.355957H91.2495L93.8802 9.52776L96.5109 0.355957H101.639V22.0843H96.9438V11.835L93.8802 20.5263L90.8499 11.835Z"
      fill="#00B033"
    />
    <path
      d="M108.266 19.3894L107.833 22.0867H102.971L107.333 0.358368H112.495L116.857 22.0867H111.995L111.562 19.3894H108.266ZM108.799 15.9428H111.03L109.931 8.24098L108.799 15.9428Z"
      fill="#00B033"
    />
    <path
      d="M321.692 17.919L329.762 4.12928C329.762 4.12928 332.571 0.0945023 337.627 1.21811C342.683 2.34172 343.245 4.89537 346.667 10.4113L337.116 26.8568L321.692 17.919Z"
      fill="#00B033"
    />
    <path
      d="M376.494 23.1693L384.477 37.0101C384.477 37.0101 386.592 41.4494 383.111 45.284C379.63 49.1206 377.133 48.3443 370.647 48.5853L361.09 32.1439L376.494 23.1714V23.1693Z"
      fill="#00B033"
    />
    <path
      d="M344.88 68.0728L328.902 68.0605C328.902 68.0605 324.001 67.6703 322.422 62.7367C320.842 57.803 322.763 56.0318 325.801 50.2932L344.818 50.2462L344.88 68.0728Z"
      fill="#00B033"
    />
    <path
      d="M340.861 0.357996H361.358C361.358 0.357996 362.992 0.300795 363.895 1.55924C364.798 2.81972 369.497 10.8709 369.497 10.8709L374.741 7.68801L366.228 23.0774L348.726 22.7873L354.105 19.6555L345.253 4.33353C345.253 4.33353 343.296 1.1813 340.861 0.355957V0.357996Z"
      fill="#00B033"
    />
    <path
      d="M319.813 60.2136L309.672 42.4014C309.672 42.4014 308.812 41.0102 309.461 39.6026C310.111 38.195 314.783 30.1275 314.783 30.1275L309.423 27.1469L327.008 26.9303L335.415 42.2829L330.032 39.1572L321.096 54.4322C321.096 54.4322 319.325 57.6927 319.813 60.2177V60.2136Z"
      fill="#00B033"
    />
    <path
      d="M382.055 48.5424L371.869 66.3302C371.869 66.3302 371.107 67.7766 369.566 67.9339C368.026 68.0912 358.702 68.1667 358.702 68.1667L358.859 74.2996L349.734 59.2657L358.682 44.2216L358.727 50.4464L376.422 50.377C376.422 50.377 380.13 50.2442 382.057 48.5404L382.055 48.5424Z"
      fill="#00B033"
    />
  </svg>
);

export default SustentareLogo;
